import React from "react";

export default function List({ content }) {
  return (
    <ul
      style={{
        listStyle:
          content.list_icon === "none"
            ? "none"
            : content.list_icon
            ? `url(${content.list_icon})`
            : "disc inside",
        margin: content.component_margin ? content.component_margin : "0px",
      }}
    >
      {content.content.map((item) => {
        return (
          <li
          className="body-text"
            dangerouslySetInnerHTML={{ __html: item.text }}
            style={{
              margin: item.margin ? item.margin : "0px",
              padding: item.padding ? item.padding : "0px",
              width: item.width ? item.width : null,
              // fontSize: item.font_size ? item.font_size : null,
              fontFamily: item.font ? item.font : null,
              color: item.font_color ? item.font_color : null,
            }}
          ></li>
        );
      })}
    </ul>
  );
}
